export default function timeoutPromise(millis: number) {
	return new Promise<void>((resolve) => {
		setTimeout(resolve, millis);
	});
}
